import { styled } from "@mui/material";

const ListItem = styled("li")({});

export type ListItemProps = typeof ListItem extends (props: infer P) => any ? P : never;

export default ListItem;
